<div class="flex flex-col gap-medpace">
    @for (transferFormGroup of formGroup().controls.transfers.controls; track $index) {
        <medpace-transfer-data
            [index]="$index"
            [mode]="'view'"
            [timeOptions]="timeOptions()"
            [formGroup]="transferFormGroup"
        />
    }
    <div class="o-grid__row">
        <div class="o-grid__item">
            <div class="c-info__block">
                <h5>Special Requests</h5>
                <span>{{ formGroup().controls.specialRequests.value ?? 'Unspecified' }}</span>
            </div>
        </div>
    </div>
</div>
